import React, { useEffect, useRef, useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { Form, Modal } from 'react-bootstrap';
import { handleDelete, handleSubmit as modalSubmit } from '../../components/modals/ModalHelpers';
import DynModal from '../../components/modals/DynModal';
import ButtonCard from '../../components/cards/ButtonCard';
import ButtonGroup from '../../components/modals/ButtonGroup';
import InputField from '../../components/form/InputField';
import PagedTable from '../../components/table/PagedTable';
import Bivema from '../../common/Bivema';

const columnsTeachingFormat = [
  { title: 'Durchführungsart', name: 'type' },
  { title: 'Edit', name: '_links.self.href' },
];

const defaultTeachingFormat = {
  type: '',
};

const teachingFormatValidationSchema = Yup.object().shape({
  type: Yup.string()
    .max(50, 'Darf maximal 50 Zeichen lang sein.')
    .required('Bitte geben Sie eine Durchführungsart ein.'),
});

const TeachingFormatOverview = () => {
  const [update, setUpdate] = useState(false);
  const [selfLink, setSelfLink] = useState();
  const [showDynModal, setShowDynModal] = useState(false);
  const [classNameDynModal, setClassNameDynModal] = useState('dynModal');

  const [teachingFormat, setTeachingFormat] = useState({
    ...defaultTeachingFormat,
  });

  // needed for formik, to pass it to the modal and set the values
  const formikRef = useRef();

  // set Tab Title
  useEffect(() => {
    document.title = 'Durchführungsart | Stammdaten';
  }, []);

  useEffect(() => {
    if (teachingFormat._links !== undefined) {
      setSelfLink(teachingFormat._links.self.href);
    }

    // sets formik values
    if (formikRef.current && teachingFormat !== formikRef.current.values) {
      formikRef.current.setValues(teachingFormat);
    }
  }, [teachingFormat]);
  return (
    <div className="container-fluid">
      <ButtonCard title="Durchführunsart" className="mt-2" setShowDynModal={setShowDynModal}>
        <DynModal
          className={classNameDynModal}
          headerTitle="Durchführungsart"
          setEntity={setTeachingFormat}
          defaultEntity={defaultTeachingFormat}
          settersToReset={[setSelfLink]}
          formikRef={formikRef}
          show={showDynModal}
          setShow={setShowDynModal}
          modalBody={(
            <Formik
              innerRef={formikRef}
              initialValues={teachingFormat}
              onSubmit={(values, submitProps) => modalSubmit(
                values,
                submitProps,
                setUpdate,
                Bivema.TEACHING_FORMATS,
                selfLink,
              )}
              validateOnChange={false} // because at the moment on change validates all fields
              validationSchema={teachingFormatValidationSchema}
            >
              {({
                errors, touched, handleSubmit, handleReset, handleChange, values,
              }) => (
                <Form onSubmit={handleSubmit} onReset={handleReset}>
                  <Modal.Body>
                    <Form.Group controlId="teachingFormat-group">
                      <InputField
                        value={values.type}
                        handleChange={handleChange}
                        touched={touched.type}
                        errorDescription={errors.type}
                        fieldName="type"
                        placeholder="Durchführungsart*"
                      />
                    </Form.Group>
                  </Modal.Body>
                  <Modal.Footer>
                    <ButtonGroup
                      handleDelete={() => handleDelete(selfLink, setUpdate)}
                      selfLink={selfLink !== undefined}
                      setShowDynModal={setShowDynModal}
                      setClassNameDynModal={setClassNameDynModal}
                    />
                  </Modal.Footer>
                </Form>
              )}
            </Formik>
          )}
        />
        <PagedTable
          entityName={Bivema.TEACHING_FORMATS}
          columns={columnsTeachingFormat}
          pageSize={10}
          setShowDynModal={setShowDynModal}
          setEntity={setTeachingFormat}
          setUpdate={setUpdate}
          update={update}
        />
      </ButtonCard>
    </div>
  );
};

export default TeachingFormatOverview;
